export default "/app-page/javascript/public/images/veryHeavy-43485d9b227b07bb.png"